import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { GamesContext, IGamesContext } from '../../gamesState/gamesContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Games.module.scss';

const Games: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, games, currentPage, countOfItems } = useContext<IGamesContext>(GamesContext);

	return (
		<>
			{games.gamesCount ? (
				<div className={style.container} data-test="Games">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={games.gamesCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Games;
